import { createApiAction } from '@app/packages/api/utils'
import type { V3GetSitterStatisticsParams } from '@app/packages/api/v3/types/params'
import type { V3GetSitterStatisticsResponse } from '@app/packages/api/v3/types/responses'

export const getSitterStatistics = (params?: V3GetSitterStatisticsParams) =>
  createApiAction('getSitterStatistics', dispatch =>
    dispatch<V3GetSitterStatisticsResponse>({
      endpoint: `/api/v3/sitter_statistics${buildSitterStatisticsQuery(params)}`,
      method: 'GET',
    })
  )

const buildSitterStatisticsQuery = (params?: V3GetSitterStatisticsParams): string => {
  if (!params) return ''
  const search = new URLSearchParams()
  if (params.from) search.set('filter[from]', params.from)
  if (params.to) search.set('filter[to]', params.to)
  const qs = search.toString()
  return qs ? `?${qs}` : ''
}
